import { render } from "./AwardTable.vue?vue&type=template&id=2ce971c5"
import script from "./AwardTable.vue?vue&type=script&lang=js"
export * from "./AwardTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__